import React from "react";
import "../styles/services.css";

const servicesData = [
  {
    title: "What is HomoDial?",
    subtitle: "Your Trusted Home Healthcare Partner",
    desc: `HomoDial Healthcare Solution Pvt. Ltd. is a trusted home healthcare company dedicated to providing complete medical care and support at home for senior citizens, elderly patients, and individuals with long-term or chronic health conditions.
Our patients benefit from qualified doctors, trained nurses, essential medical equipment at home, regular health monitoring, emergency support, and personalized care ensuring safety, comfort, and peace of mind for both patients and their families.`,
 image:
      "WhatsApp Image 2026-01-28 at 9.57.30 PM.jpeg",
    layout: "left",
  },

  {
    title: "Expert Healthcare at Your Home",
    subtitle: "Complete Support for Elderly Well-Being",
    desc: `As people age, health needs become more complex ranging from mobility challenges and chronic conditions to the need for continuous medical supervision. At the same time, seniors deserve comfort, dignity, and care in a familiar home environment.`,
    image:
      "doctor-at-home.webp",
    layout: "right",

  },
  {
    title: "How Can We Help You?",
    subtitle: "Personalized Home Healthcare Solutions",
    desc: `HomoDial Healthcare Solution Pvt. Ltd. offers structured home healthcare programs designed to meet varying levels of medical and personal care needs.
     Our approach ensures continuity of care, proactive health supervision, and complete peace of mind for families.`,
    image:
      "Untitled-design-9.jpg",
    layout: "left",
  },
  {
    title: "Flexible Care Programs & Add-On Services",
    subtitle: "Care That Fits Individual Needs",
    desc: `Based on the patient’s condition and level of assistance required, families can choose from comprehensive care programs or enhance them with specialized add-on services. These include trained nursing support, medical equipment at home, regular health monitoring, 
    emergency assistance, and customized care plans—ensuring the right support at the right time.`,
    image:
      "Elderly-day-care-scaled-min.jpg",
    layout: "right",
  },
];

export default function Services() {
  return (
    <section className="services-section" id="services">
      <h2 className="services-title">Our HomoDial Healthcare Services</h2>

      {servicesData.map((service, index) => (
        <div
          key={index}
          className={`service-box ${
            service.layout === "left" ? "left-image" : "right-image"
          }`}
        >
          <div className="service-image">
            <img src={service.image} alt={service.title} />
          </div>

          <div className="service-content">
            <h3>{service.title}</h3>
            <h4>{service.subtitle}</h4>
            <p>{service.desc}</p>
          </div>
        </div>
      ))}
    </section>
  );
}
